// extracted by mini-css-extract-plugin
export default {"container":"MarketingMaterialsCard_container__jFkDF"};